import React from "react";
import FooterSection from "../../components/FooterSection/Footer";
import CTACompanies from "../../components/AppSections/HomepageSections/CTACompanies";
import {Helmet} from "react-helmet";
import {appWords} from "../../config/Constants";
import {stringsTranslate} from "../../locales/CustomTranslater";
import NewBannerSectionForCompanies from "../../components/AppSections/ForCompanies/NewBannerSectionForCompanies";
import Section2ForCompanies from "../../components/AppSections/ForCompanies/Section2ForCompanies";
import Section4ForCompanies from "../../components/AppSections/ForCompanies/Section4ForCompanies";
import Section6ForCompanies from "../../components/AppSections/ForCompanies/Section6ForCompanies";
import Section3ForCompanies from "../../components/AppSections/ForCompanies/Section3ForCompanies";
import Section5ForCompanies from "../../components/AppSections/ForCompanies/Section5ForCompanies";
import Section7ForCompanies from "../../components/AppSections/ForCompanies/Section7ForCompanies";
import SectionButton34ForCompanies from "../../components/AppSections/ForCompanies/SectionButton3-4ForCompanies";

export default function ForCompanies() {
    const for_companies_cl = stringsTranslate(appWords.for_companies_cl)
    return (
        <div className={"homepage-4 pt-5 mt-5 banner-section-for-companies"}>
            <Helmet>
                <title>Knaek - {for_companies_cl}</title>
            </Helmet>
            <div className="main">
                <NewBannerSectionForCompanies/>
                <Section2ForCompanies/>
                <Section3ForCompanies/>
                <SectionButton34ForCompanies/>
                <Section4ForCompanies/>
                <Section5ForCompanies/>
                <Section6ForCompanies/>
                <Section7ForCompanies/>
                {/*{WEBSITE_TYPE === appLanguage.nl && (*/}
                {/*    <PricingCard/>*/}
                {/*)}*/}
                <CTACompanies/>
                <FooterSection/>
            </div>
        </div>
    );
}
